import { Gender, IdentityDocumentType } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { isoDateString } from '../_shared/dates.js';
import { personName } from '../_shared/person-name.js';
export const affidiumPassengerPatchSchema = z.object({
    travellerId: z.string().min(1),
    birthDate: isoDateString(),
    gender: z.nativeEnum(Gender),
    identityDocumentExpiryDate: isoDateString().nullish(),
    identityDocumentNumber: z.string().nullish(),
    identityDocumentType: z.nativeEnum(IdentityDocumentType).nullish(),
    issuingCountry: z.string().length(3).nullish(),
    nationalityCode: z.string().length(3),
    price: z.number().optional(),
});
export const createBookingFromAffidiumSchema = z.object({
    clientId: z.string().optional(),
    reservationId: z.string().optional(),
    accountCode: z.string().optional(),
    bookingReference: z.string().min(1),
    depositAmountOverride: z.number().optional(),
    depositDeadlineOverride: isoDateString().optional(),
    exchangeAllowed: z.boolean(),
    exchangeFeeDescription: z.string(),
    igaReference: z.string().optional(),
    installmentPaymentDeadlineOverride: isoDateString().optional(),
    passengers: z.array(affidiumPassengerPatchSchema).optional(),
    refundAllowed: z.boolean(),
    refundFeeDescription: z.string(),
    sendReservationContract: z.boolean().optional(),
});
export const reconcileBookingPassengerItemSchema = z.object({
    bookingPassengerId: z.string().min(1),
    firstName: personName({ optional: true }),
    lastName: personName({ optional: true }),
    targetPassengerId: z.string().min(1).optional(),
    action: z.enum(['CREATE', 'LINK', 'SKIP']),
    birthDate: isoDateString().optional(),
    gender: z.nativeEnum(Gender).optional(),
    nationalityCode: z.string().min(2).optional(),
});
export const reconcileBookingPassengersSchema = z.object({
    dryRun: z.boolean(),
    items: z.array(reconcileBookingPassengerItemSchema).optional(),
});
export const updateBookingPassengerSchema = z.object({
    firstName: personName({ optional: true }),
    lastName: personName({ optional: true }),
    birthDate: isoDateString().nullish(),
    gender: z.nativeEnum(Gender).optional(),
    identityDocumentExpiryDate: isoDateString().nullish(),
    identityDocumentNumber: z.string().nullish(),
    identityDocumentType: z.nativeEnum(IdentityDocumentType).nullish(),
    issuingCountry: z.string().length(3).nullish(),
    nationalityCode: z.string().length(3).optional(),
    price: z.number().int().min(0).optional(),
});
